import React from "react";
import Select from "react-select";
import { CircularAvatar } from "../../../commons";
import { components } from "react-select";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalenderIcon, PlusIconCircle } from "../../../Icon";
import { Button } from "react-bootstrap";
import AddMoreInterviewerDetails from "./AddMoreInterviewerDetails";
import { InputDetailsErrorType } from "./index";

type AppProps = {
  recruiterLimit: number;
  recruiterOffset: number;
  recruiterText: string;
  finalRecruiterList: any;
  userFetching: boolean;
  setRecruiterText: React.Dispatch<React.SetStateAction<string>>;
  setRecruiterOffset: React.Dispatch<React.SetStateAction<number>>;
  interviewDetails: any;
  interviewerInputDetails: any;
  handleRemoveRow: (data: any) => void;
  handleAddAnotherDetails: () => void;
  handleInterviewsInputDetailsChange: (
    dataKey: any,
    value: any,
    index: number
  ) => void;
  handleInterviewFormDetailsChange: (dataKey: string, value: any) => void;
  inputDetailsError: InputDetailsErrorType;
};
const InterViewDetails = ({
  recruiterLimit,
  recruiterOffset,
  recruiterText,
  finalRecruiterList,
  setRecruiterText,
  setRecruiterOffset,
  userFetching,
  interviewDetails,
  interviewerInputDetails,
  handleRemoveRow,
  handleAddAnotherDetails,
  handleInterviewsInputDetailsChange,
  handleInterviewFormDetailsChange,
  inputDetailsError,
}: AppProps) => {
  const checkBottom = (e: any) => {
    setRecruiterOffset((prv: any) => prv + recruiterLimit);
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  return (
    <>
      <div className="mb-2" style={{ marginTop: "75px" }}>
        <h5 style={{ fontSize: "15px", fontWeight: "600" }}>
          INTERVIEW DETAILS
        </h5>
      </div>
      <div className="row">
        <div className="col-md-3">
          <label className="mb-1" htmlFor="dateOfConformation">
            Application Date <span className="color-red">*</span>
          </label>
          <div className="d-flex flex-row position-relative">
            <div className="date-picker-wraper mr-0 w-100">
              <Label className="mr-0 w-100">
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    interviewDetails?.applicationDate
                      ? new Date(
                          moment(
                            `${interviewDetails?.applicationDate}T00:00:00`,
                            "YYYY-MM-DD"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      :  null
                  }
                  onChange={(e: any) => {
                    handleInterviewFormDetailsChange?.(
                      "applicationDate",
                      moment(e).format("YYYY-MM-DD")
                    );
                  }}
                  disabled={true}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  //   disabled={!isEdit}
                  // name="date_of_birth"
                  placeholderText="Select"
                  className={`${
                    inputDetailsError?.applicationDateError
                      ? "error-border rounded form-control"
                      : "form-control"
                  }`}
                />
                <span
                  className="calender-icon"
                  style={{
                    right: "20px",
                    top: "10px",
                    cursor: "pointer",
                  }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
          {!!inputDetailsError?.applicationDateError && (
            <small className="text-danger">
              {inputDetailsError?.applicationDateError}
            </small>
          )}
        </div>
      </div>
      {/* <div className="row">
        
      </div> */}
      <div className="row mt-3">
        <div className="col-md-3">
          <label className="mb-1" htmlFor="phoneScreeningDateAndTime">
            Phone Screening Date & Time 
          </label>
          <div className="form-group">
            <div className="date-picker-wraper mr-0">
              <Label className="m-0 p-0 w-100">
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    interviewDetails?.phoneScreeningDateAndTime
                      ? new Date(
                          moment(
                            `${interviewDetails?.phoneScreeningDateAndTime}T00:00:00`,
                            "YYYY-MM-DD, HH:mm"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    handleInterviewFormDetailsChange(
                      "phoneScreeningDateAndTime",
                      moment(e).format("YYYY-MM-DD, HH:mm")
                    );
                  }}
                  fixedHeight
                  showMonthDropdown
                  value={interviewDetails?.phoneScreeningDateAndTime}
                  showYearDropdown
                  name="phoneScreeningDateAndTime"
                  placeholderText="Choose"
                  className={`${
                    inputDetailsError?.phoneScreeningDateAndTimeError
                      ? "error-border rounded form-control"
                      : "form-control"
                  }`}
                  showTimeSelect
                  timeFormat="HH:mm"
                />
                <span
                  className="calender-icon"
                  style={{ right: "30px", top: "30px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <label className="mb-1" htmlFor="phoneScreener">
            Phone Screener 
          </label>
          <Select
            // styles={dropDownStyle}
            className={`${
              inputDetailsError?.phoneScreenerError
                ? "error-border rounded"
                : ""
            }`}
            value={interviewDetails?.phoneScreener}
            options={finalRecruiterList}
            components={{ Option }}
            onChange={(e) =>
              handleInterviewFormDetailsChange("phoneScreener", e)
            }
            isSearchable={true}
            isLoading={userFetching && recruiterText?.length > 0}
            onMenuClose={() => {
              setRecruiterOffset(0);
            }}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            // isDisabled={isDisabled}
            onInputChange={(e) => {
              setRecruiterText(e);
            }}
          />
        </div>
        <div className="col-md-5">
          <label className="mb-1" htmlFor="interviewFeedback">
            Interview Feedback
          </label>
          <div>
            <textarea
              className={`form-control`}
              name="interviewFeedback"
              onChange={(e) =>
                handleInterviewFormDetailsChange(
                  "interviewFeedback",
                  e.target.value
                )
              }
              value={interviewDetails?.interviewFeedback}
            />
          </div>
        </div>
      </div>
      <AddMoreInterviewerDetails
        setRecruiterOffset={setRecruiterOffset}
        recruiterLimit={recruiterLimit}
        recruiterOffset={recruiterOffset}
        recruiterText={recruiterText}
        finalRecruiterList={finalRecruiterList}
        setRecruiterText={setRecruiterText}
        userFetching={userFetching}
        handleRemoveRow={handleRemoveRow}
        interviewerInputDetails={interviewerInputDetails}
        Option={Option}
        handleInterviewsInputDetailsChange={handleInterviewsInputDetailsChange}
      />
      <div className="row mt-3 mb-3">
        <div className="col-3">
          <button
            disabled={
              interviewerInputDetails[interviewerInputDetails?.length - 1]
                ?.interviewFeedback?.length === 0
            }
            className="btn btn-outline"
            onClick={handleAddAnotherDetails}
          >
            <PlusIconCircle />
            <span className="ml-2">Add More Row</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default InterViewDetails;
